<template>
    <div class="totalWidthBox">
        <div class="top clearfix">
            <el-button class="perBtn funcPublicBtn funcPublicBtnChecked" v-if="isEdit&&!hidePer" @click="perDialog=!perDialog"> 百分比</el-button>
            <div class="title">{{widthObj.widthType?widthObj.widthType==2?'码单宽度明细':'销售宽度明细':'宽度明细'}}</div>
            <div class="change" v-if="isCanEdit" @click="isEdit=!isEdit">{{isEdit?'取消修改':'修改'}}</div>
        </div>
        <div class="widthList" v-for="(list,index) in widthObj.widthList" :Key="index">
            <div class="path">
                <span class="pathTitle">{{list.thickness}}*{{list.length}}</span>
                <img src="/icon/codelist_edit.png" class="pathTitleImg" @click="changeSpec(index)" v-if="isEdit"/>
            </div>
            <div class="widthlistC clearfix">
                <div class="widthInputC" v-for="(item,ind) in list.width" :Key="ind">
                    <el-input class="widthInput" v-model="widthObj.widthList[index].width[ind]" :readonly="!isEdit"></el-input>
                    <div class="delWidth" v-if="isEdit" @click="delWidth(index,ind)"></div>
                </div>
                <div class="addWidth" @click="addWidth(index)" v-if="isEdit"></div>
            </div>
            <div class="calcBox clearfix">
                <div class="calCShell clearfix">
                    <div class="calC clearfix">
                        <div class="caclTitle">平均宽度个数：</div>
                        <input class="value" :disabled="!isEdit" v-model="list.veneer_avg"/>
                    </div>
                    <div class="calC clearfix">
                        <div class="caclTitle">层数：</div>
                        <input class="value" :disabled="!isEdit" v-model="list.layer_number"/>
                    </div>
                    <div class="calcBtn" v-if="isEdit" @click="calCube(index)">开始计算</div>
                </div>
                <div class="total">{{list.cube}}m³</div>
            </div>
        </div>
        <div class="noWidth"  v-if="widthObj.widthList.length<=0&&!isEdit">暂无宽度明细</div>
        <div class="dialogBtnList clearfix" v-if="isEdit">
            <el-button  class="publicBtn dialogBtn" @click="widthEdit">修改</el-button>
            <el-button class="dialogBtn funcPublicBtn" @click="cancel">取消</el-button>
        </div>
        <!-- 修改百分比 START -->
        <el-dialog v-dialog-drag :visible.sync="perDialog" class="eldialog eldialogOneLabel totalChangeWidth" width="400px" :modal="false" title="修改百分比" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item label="请输入百分比:">
                        <el-input class="edit_input" v-model="cube" @change="setNumber" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="changePer">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="perDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 修改百分比 END -->
        <!-- 规格修改 START -->
        <el-dialog v-dialog-drag :visible.sync="guigeDialog" class="eldialog eldialogOneLabel totalChangeWidth spec" width="300px" :modal="false" title="规格修改" custom-class="full_dialog">
            <div class="">
                <el-form>
                    <el-form-item label="厚度:">
                        <el-input class="edit_input" v-model="spec.thickness" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="长度:">
                        <el-input class="edit_input" v-model="spec.length" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="changeSpecConfirm">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="guigeDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 规格修改 END -->
    </div>
</template>
<script>
export default {
    props:['edit','type','widthid','list','ispost','dialogvisible','noChuanshen','issetper','perval','isHidePer',"saleedit","widthSaleInventoryId"],
    data(){
        return{
            guigeDialog:false,
            widthObj:{
                id:this.widthid,
                widthList:this.list,
                widthType:this.type,//2.码单 3.销售
            },
            spec:{
                thickness:"",
                length:""
            },
            specIndex:"",
            changeType:this.ispost,
            oldList:this.list,
            isEdit:false,
            isCanEdit:this.edit,
            perDialog:false,
            cube:"",
            isSetPerVal:this.issetper,
            setPerVal:this.perval,
            hidePer:this.isHidePer,
        }
    },
    methods:{
        changeSpec(index){
            this.specIndex = index;
            this.spec.thickness = this.widthObj.widthList[index].thickness;
            this.spec.length = this.widthObj.widthList[index].length;
            this.guigeDialog = true;
        },
        changeSpecConfirm(){
            this.widthObj.widthList[this.specIndex].thickness = this.spec.thickness;
            this.widthObj.widthList[this.specIndex].length = this.spec.length;
            this.guigeDialog = false;
        },
        calCube(index){
            let obj = new Object();
            obj.sales_width = this.widthObj.widthList;
            obj.inventory_id = this.widthSaleInventoryId;
            this.postFuncLoading("/erp/order.update.width",obj,res=>{
                this.widthObj.widthList = res.data.data.sales_width;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        setNumber(val){
            let reg = new RegExp("^(\\+)?\\d+(\\.\\d+)?$");
            if(reg.test(val)){
                if(this.isSetPerVal){
                    if(Number(val)<1&&Number(val)!=0){
                        this.tip("输入的值不能小于1","warning")
                        return;
                    }
                }
                this.cube = val;
            }else{
                this.tip("请输入数字","warning")
            }
        },
        changePer(){
            if(Number(this.cube)!=0&&Number(this.cube)>1){
                let list = JSON.parse(JSON.stringify(this.widthObj.widthList));
                list.forEach((item,index)=>{
                    item.width.forEach((val,ind)=>{
                        list[index].width[ind] = Number(val)?Math.round(Number(val)*Number(this.cube)):'';
                    })
                    // list[index] = Number(item)?Number(item)*Number(this.cube):'';
                })
                this.widthObj.widthList = list;
                this.perDialog = false;
            }else if(Number(this.cube)==0){
                this.widthObj.widthList = JSON.parse(JSON.stringify(this.oldList));
                this.perDialog = false;
            }
        },
        addWidth(index){
            this.widthObj.widthList[index].width.push(null)
        },
        delWidth(index,ind){
            this.widthObj.widthList[index].width.splice(ind,1)
        },
        cancel(){
            this.$emit("cancelWidth")
        },
        widthEdit(){
            if(this.ispost){
                let obj = new Object();
                obj.id=this.widthObj.id;
                if(this.widthObj.widthType==2){
                    obj.width=this.widthObj.widthList;
                }else{
                    obj.sales_width=this.widthObj.widthList;
                }
                this.postFunc("/erp/inventory.update.width",obj,()=>{
                    this.tip('修改成功','success');
                    this.$emit("changeSuccess")
                    this.$emit("cancelWidth")
                    this.$emit("saleChange",res.data.data)
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }else if(this.saleedit){
                let obj = new Object();
                obj.sales_width = this.widthObj.widthList;
                obj.inventory_id = this.widthSaleInventoryId;
                this.postFunc("/erp/order.update.width",obj,res=>{
                    this.tip('修改成功','success');
                    // this.$emit("changeSuccess")
                    this.$emit("saleChange",res.data.data)
                    this.$emit("cancelWidth")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }else if(this.noChuanshen){
                this.tip('修改成功','success');
                this.$emit("cancelWidth")
                if(this.widthObj.widthType == 2){  // 码单总宽度
                    this.$emit("returnwidth",JSON.parse(JSON.stringify(this.widthObj.widthList)))
                }else if(this.widthObj.widthType == 3){  // 销售总宽度
                    this.$emit("returnSalewidth",JSON.parse(JSON.stringify(this.widthObj.widthList)))
                }
            }else{
                this.tip('修改成功','success');
                this.$emit("cancelWidth")
                this.$emit("returnwidth",JSON.parse(JSON.stringify(this.widthObj.widthList)))
            }
        },
    },
    watch:{
        
        guigeDialog:function(val){
            if(!val){
                this.spec = this.resetJson(this.spec)
            }
        },
        edit:function(val){
            this.isCanEdit = val;
        },
        type:function(val){
            this.widthObj.widthType = val;
        },
        widthid:function(val){
            this.widthObj.id = val;
        },
        list:function(val){
            this.widthObj.widthList = JSON.parse(JSON.stringify(val));
            this.oldList = JSON.parse(JSON.stringify(val));
        },
        perDialog:function(val){
            if(!val){
                this.cube = "";
            }
        },
        ispost:function(val){
            this.changeType = val;
        },
        dialogvisible:function(val){
            if(val){
                this.isEdit = false;
                this.widthObj.widthList = JSON.parse(JSON.stringify(this.oldList));
                // this.widthObj.widthList.forEach(item=>{
                //     item.veneer_avg = item.width.length
                // })
            }
        },
        issetper:function(val){
            this.isSetPerVal = val;
        },
        perval:function(val){
            this.setPerVal = val;
        },
        isHidePer:function(val){
            this.hidePer = val;
        }
    }
}
</script>
<style scoped>
    .spec >>> .el-form-item__label{width:50px;}
    .spec >>> .el-form-item__content{width:200px;}

    .pathTitleImg{width:17px;height:17px;display: inline;margin-left:10px;position: relative;top:2px;cursor: pointer;}
    .calcBox .calCShell{background-color: #ebedf4;float: left;padding:10px 0;padding-right:10px;border-radius: 5px 0 0 5px;width:455px;}
    .calcBox .calC{float: left;margin-left: 20px;}
    .calcBox .caclTitle{font-size: 14px;line-height: 30px;float: left;}
    .calcBox .value{height:30px;line-height: 30px;font-size: 14px;padding:0 5px;width:80px;border-radius: 5px;border:1px solid #ccc;float: left;outline: none;}
    .calcBox .calcBtn{float: left;margin-left: 20px;font-size: 12px;color:#fff;background-color:#e25858;border-radius: 3px;height:30px;line-height: 30px;padding:0 15px;cursor: pointer;}
    .calcBox .total{background-color: #ebedf4;font-size: 14px;line-height: 30px;margin-left:5px;float: left;padding:10px 20px;border-radius: 0 5px 5px 0;width:120px;font-weight: 600;}

    .totalWidthBox .top{position: relative;height: 45px;border-bottom: 1px solid #888;padding:0 20px;padding-top:5px;}
    .totalWidthBox .perBtn{float: left;position: relative;z-index: 1;}
    .totalWidthBox .title{position: absolute;left:0;right:0;margin: auto;line-height: 33px;z-index: 0;font-size: 16px;}
    .totalWidthBox .change{float:right;line-height: 33px;color: #b21111;cursor: pointer;position: relative;z-index: 1;}
    .delWidth{width:15px;height:15px;position: absolute;top:0;right:0;background: url('../assets/top-delete-suspension.png') no-repeat 100% 100%;background-size: 100% 100%;cursor: pointer;}
    .addWidth{position: relative; width:50px;height:50px;float:left;background: url('../assets/plus-hover@2x.png') no-repeat 50% 50%;background-size: 50% 50%;cursor: pointer;}
    .noWidth{padding:20px 0;background-color: #ececec;color:#777;}
    .path{margin-bottom: 7px;text-align: left;}
    .path .pathTitle{font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;}
</style>